export default "__VITE_ASSET__Fs__EOdB__"